module.exports = __webpack_public_path__ + "img/examples-ru-3.fbbd9ecb.jpg";